import { quickCategories, genreList } from "@/mocks/siteContent";

const navGroups = [
  {
    title: "浏览导航",
    links: [
      { label: "首页", href: "#top" },
      { label: "影视资源库", href: "#catalog" },
      { label: "剧集热播", href: "#series" },
      { label: "口碑高分榜", href: "#top-rated" },
    ],
  },
  {
    title: "帮助与说明",
    links: [
      { label: "按类型浏览", href: "#genres" },
      { label: "观影指南", href: "#guide" },
      { label: "关于本站", href: "#about" },
      { label: "常见问题", href: "#guide" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-accent-950 pt-14 text-background-100 md:pt-16">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="grid gap-10 pb-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">星辰影院</span>
                <span className="text-[11px] tracking-wide text-background-300">STAR CINEMA</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              星辰影院聚合最新电影与热门电视剧资源，支持在线浏览查看，画质高清、更新及时。追新剧、补经典老片，一站直达。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {quickCategories.slice(1).map((cat) => (
                <span key={cat} className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          {navGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{group.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 transition-colors hover:text-primary-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/15 py-6">
          <p className="mb-4 text-xs text-background-300">
            热门题材：
            {genreList.slice(0, 8).map((genre, index) => (
              <a
                key={genre.name}
                href="#genres"
                className="transition-colors hover:text-primary-300"
              >
                {genre.name}
                {index < 7 ? "、" : ""}
              </a>
            ))}
          </p>
          <div className="flex flex-col gap-2 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2026 星辰影院 · 本站为影视资源信息聚合展示，内容仅供学习与参考。</p>
            <p>页面数据为示例内容，用于演示浏览与筛选功能。</p>
          </div>
        </div>
      </div>
    </footer>
  );
}